export default {
  routerList: [
    {
      path: "/pages/Demo",
      component: (resolve) => require(["@/pages/a_Demo/Demo/"], resolve),
      meta: {
        title: "模板页",
        keepAlive: true,
      },
    },

    //========业务订单========
    {
      path: "/WaybillManage/ComprehensiveQuery",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/ComprehensiveQuery",
        ], resolve),
      meta: {
        title: "全部运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCreate",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreate"], resolve),
      meta: {
        // 合世
        title: "新建运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCreateRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], resolve),
      meta: {
        // 荣祥
        title: "新建运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillEdit",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillEdit"], resolve),
      meta: {
        // 合世
        title: "修改运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillEditRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillEditRX"], resolve),
      meta: {
        // 荣祥
        title: "修改运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillEditRXJC",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillEditRXJC"], resolve),
      meta: {
        // 荣祥
        title: "修改基础信息",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCaiWuRuLuRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCaiWuRuLuRX"], resolve),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillPostingRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillPostingRX/WaybillPostingRX"], resolve),
      meta: {
        title: "运单过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TrackingWaybill",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TrackingWaybill"], resolve),
      meta: {
        title: "运单跟踪",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TrackingWaybillAddy",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TrackingWaybillAddy"], resolve),
      meta: {
        title: "跟踪录入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TrackingWaybillSelect",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TrackingWaybillSelect"], resolve),
      meta: {
        title: "运单查询",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillDetails",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/WaybillDetails",
        ], resolve),
      meta: {
        title: "运单详情",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillSigne",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillSigne"], resolve),
      meta: {
        title: "运单签收",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/Waybillimport",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/Waybillimport"], resolve),
      meta: {
        title: "运单导入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillimportDetail",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/WaybillimportDetail",
        ], resolve),
      meta: {
        title: "导入预览",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/Posting",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/Posting"], resolve),
      meta: {
        title: "过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TransportationPlann",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/TransportationPlann",
        ], resolve),
      meta: {
        title: "运单运输规划",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/SplitOrder",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/SplitOrder"], resolve),
      meta: {
        title: "拆单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TestPage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TestPage"], resolve),
      meta: {
        title: "动态查询",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingManage",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/OutgoingManage",
        ], resolve),
      meta: {
        title: "外发列表",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingAdd",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingAdd"], resolve),
      meta: {
        title: "新建外发",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingEdit",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingEdit"], resolve),
      meta: {
        title: "修改外发",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingPosting",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/OutgoingPosting",
        ], resolve),
      meta: {
        title: "外发过账",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionManage",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionManage",
        ], resolve),
      meta: {
        title: "异常列表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionAdd",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionAdd",
        ], resolve),
      meta: {
        title: "新建异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionModify",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionModify",
        ], resolve),
      meta: {
        title: "修改异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionEdit",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionEdit",
        ], resolve),
      meta: {
        title: "跟进异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionDetils",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionDetils",
        ], resolve),
      meta: {
        title: "异常详情",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionHeDing",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/ExceptionHeDing",
        ], resolve),
      meta: {
        title: "责任核定",
        keepAlive: true,
      },
    },
    {
      path: "/BusinessOrder/DeliveryNotice",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/DeliveryNotice"], resolve),
      meta: {
        title: "送货通知",
        keepAlive: true,
      },
    },
    {
      path: "/BusinessOrder/ReceiptManage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ReceiptManage"], resolve),
      meta: {
        title: "回单管理",
        keepAlive: true,
      },
    },

    // 系统设置=>基础设置
    {
      path: "/SystemSetting/RegionalMaintenance",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/RegionalMaintenance",
        ], resolve),
      meta: {
        title: "地区维护",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/organizationalStructure",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/organizationalStructure",
        ], resolve),
      meta: {
        title: "组织架构",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/ArticleManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/ArticleManagement/ArticleManagement",
        ], resolve),
      meta: {
        title: "文章管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AddSystemArticle",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/ArticleManagement/AddSystemArticle",
        ], resolve),
      meta: {
        title: "新建文章",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AppVersionManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AppVersionManagement",
        ], resolve),
      meta: {
        title: "app版本管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/SystemVISettings",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/SystemVISettings",
        ], resolve),
      meta: {
        title: "系统VI设置",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/GoodsCategoryType",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/GoodsCategoryType",
        ], resolve),
      meta: {
        title: "货物品类类型",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/GoodsCategory",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/GoodsCategory"], resolve),
      meta: {
        title: "货物品类",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/CargoMaintenance",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/CargoMaintenance",
        ], resolve),
      meta: {
        title: "货物维护",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/RoleManagement",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/RoleManagement"], resolve),
      meta: {
        title: "角色管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/EmployeeManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/EmployeeManagement",
        ], resolve),
      meta: {
        title: "员工管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/OperationLog",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/OperationLog"], resolve),
      meta: {
        title: "操作日志",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/DataDictionary",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/DataDictionary"], resolve),
      meta: {
        title: "数据字典",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AccountManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/AccountManagement",
        ], resolve),
      meta: {
        title: "账号管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/PermissionAssignmentUser",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/PermissionAssignmentUser",
        ], resolve),
      meta: {
        title: "账号权限分配",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/PermissionAssignmentRole",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/PermissionAssignmentRole",
        ], resolve),
      meta: {
        title: "角色权限分配",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/LogoSettings",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/LogoSettings",
        ], resolve),
      meta: {
        title: "logo设置",
        keepAlive: true,
      },
    },

    // 调度派车模块
    {
      path: "/DispatchCar/TransportationPlann",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/TransportationPlann/TransportationPlann",
        ], resolve),
      meta: {
        title: "运输任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/AddTransportationPlan",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/TransportationPlann/AddTransportationPlan",
        ], resolve),
      meta: {
        title: "运输规划",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/VehicleStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/VehicleStowage"], resolve),
      meta: {
        title: "配载批次",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/TasksLoaded"], resolve),
      meta: {
        title: "待配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/NewBuiltStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/NewBuiltStowage"], resolve),
      meta: {
        title: "新建配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/PreviewStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/PreviewStowage"], resolve),
      meta: {
        title: "预览配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/BatchImport",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/BatchImport"], resolve),
      meta: {
        title: "配载批量导入",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageAdd",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageAdd"], resolve),
      meta: {
        title: "新建配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageEdit",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageEdit"], resolve),
      meta: {
        title: "修改配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageEditRX",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageEditRX"], resolve),
      meta: {
        title: "修改配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/FareAllocation",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/FareAllocation"], resolve),
      meta: {
        title: "车费分摊",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/RoyaltyApportionment",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/VehicleStowage/RoyaltyApportionment",
        ], resolve),
      meta: {
        title: "提成分摊",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/dispatchCarDetails",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/VehicleStowage/dispatchCarDetails",
        ], resolve),
      meta: {
        title: "发车详情",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/ChargebackAudit",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/ChargebackAudit/ChargebackAudit",
        ], resolve),
      meta: {
        title: "退单审核",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DepartureContractManagement",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/DepartureContractManagement/DepartureContractManagement",
        ], resolve),
      meta: {
        title: "发车合同管理",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/AdjustRoute",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/AdjustRoute"], resolve),
      meta: {
        title: "调整路线",
        keepAlive: true,
      },
    },
    // 仓库管理
    {
      path: "/WarehouseManagement/WaybillInventory",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/WaybillInventory"], resolve),
      meta: {
        title: "运单库存",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/InTransitWaybill",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/InTransitWaybill"], resolve),
      meta: {
        title: "在途运单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrder",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrder"], resolve),
      meta: {
        title: "装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrderAdd",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrderAdd"], resolve),
      meta: {
        title: "新建装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrderEdit",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrderEdit"], resolve),
      meta: {
        title: "编辑装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/DeliveryConfirm",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/DeliveryConfirm"], resolve),
      meta: {
        title: "出库确认",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/WarehousingConfirm",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/WarehousingConfirm"], resolve),
      meta: {
        title: "入库确认",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/ReceiptIssueRecord",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/ReceiptIssueRecord"], resolve),
      meta: {
        title: "出入库记录",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/ReceiptIssueRecord",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/ReceiptIssueRecord"], resolve),
      meta: {
        title: "出入库记录",
        keepAlive: true,
      },
    },

    {
      path: "/message/messageList",
      component: (resolve) => require(["@/pages/message/messageList"], resolve),
      meta: {
        title: "消息通知",
        keepAlive: true,
      },
    },
    {
      path: "/message/exportList",
      component: (resolve) => require(["@/pages/message/exportList"], resolve),
      meta: {
        title: "导出记录",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages"], resolve),
      meta: {
        title: "报表明细",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages1",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages1"], resolve),
      meta: {
        title: "应收账款明细v2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages2",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages2"], resolve),
      meta: {
        title: "运单损益表(运单)V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages3",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages3"], resolve),
      meta: {
        title: "客服统计V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages4",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages4"], resolve),
      meta: {
        title: "客户应收账款情况",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages5",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages5"], resolve),
      meta: {
        title: "客户发货数据看板V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages6",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages6"], resolve),
      meta: {
        title: "报销应付统计V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages7",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages7"], resolve),
      meta: {
        title: "财务统计V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages8",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages8"], resolve),
      meta: {
        title: "客户对账单明细V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages9",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages9"], resolve),
      meta: {
        title: "承运商对账单明细V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages10",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages10"], resolve),
      meta: {
        title: "对账单明细V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages11",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages11"], resolve),
      meta: {
        title: "承运商应付账款V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages12",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages12"], resolve),
      meta: {
        title: "月应收汇总V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages13",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages13"], resolve),
      meta: {
        title: "操作数据统计报表-分拣V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages14",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages14"], resolve),
      meta: {
        title: "操作数据统计报表-派车V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages15",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages15"], resolve),
      meta: {
        title: "运单成本明细表V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages16",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages16"], resolve),
      meta: {
        title: "运营操作人员明细表V2",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages17",
      component: (resolve) => require(["@/pages/FinancialManagement/ReportManager/PublicQuotationPages17"], resolve),
      meta: {
        title: "系统操作统计V2",
        keepAlive: true,
      },
    },
    {
      path: "/refresh",
      name: 'refresh',
      component: (resolve) => require(["@/pages/refresh"], resolve),

    },
  ],
};
